import React, { useEffect } from 'react';
import './emt-generated-content.scss';
import PropTypes from 'prop-types';
import { Heading } from '@thd-olt-component-react/core-ui';
import { useDataModel, params } from '@thd-nucleus/data-sources';
import { string as stringType } from '@thd-nucleus/data-sources/react/dataModel/prop-types';
import { MarketingQuestionAnswer } from './MarketingQuestionAnswer';

export const SeoGeneratedContent = ({ nvalue }) => {
  let questionAndAnswers = [];
  let nval = (nvalue.indexOf('N-') < 0) ? `N-${nvalue}` : nvalue;

  const { loading, error, data } = useDataModel('seoGeneratedContent', { variables: { nvalue: nval }, skip: !nval });
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('seo-generated-content.ready');
  }, []);

  if (!nvalue) { return null; }
  if ((error && !data) || loading || !data?.seoGeneratedContent) { return null; }

  try {
    let jsonContent = JSON.parse(data.seoGeneratedContent);
    questionAndAnswers = jsonContent.Questions;
  } catch (err) {
    return null;
  }
  if (!questionAndAnswers || questionAndAnswers.length === 0) { return null; }
  return (
    <div>
      <Heading title="Questions & Answers" underline />
      <MarketingQuestionAnswer qaSets={questionAndAnswers} />
    </div>
  );
};
SeoGeneratedContent.displayName = 'SeoGeneratedContent';

SeoGeneratedContent.propTypes = {
  nvalue: PropTypes.string.isRequired,
};

const paramsForQuery = params({ nvalue: stringType().isRequired() });
if (paramsForQuery.string) {
  SeoGeneratedContent.dataModel = {
    seoGeneratedContent: paramsForQuery.string()
  };
}
